import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';
import PhotoUploadZone from './PhotoUploadZone';

interface UploadDropzoneCardProps {
  onFilesSelected: (files: File[]) => void;
  onBeforeOpen?: () => void;
  isReadOnly?: boolean;
  uploadProgress?: any[];
}

const UploadDropzoneCard: React.FC<UploadDropzoneCardProps> = ({
  onFilesSelected,
  onBeforeOpen,
  isReadOnly = false,
  uploadProgress = [],
}) => {
  if (isReadOnly) {
    return (
      <Card sx={styles.card}>
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.iconContainer}>
            <UploadIcon sx={styles.icon} />
          </Box>
          <Typography variant='h6' color='text.secondary' sx={styles.title}>
            Upload Disabled
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={styles.description}>
            This report is read-only. Photo uploads are not allowed.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={styles.card}>
      <CardContent sx={styles.cardContent}>
        <PhotoUploadZone onFilesSelected={onFilesSelected} onBeforeOpen={onBeforeOpen} uploadProgress={uploadProgress} />
      </CardContent>
    </Card>
  );
};

const styles = {
  card: {
    minHeight: 300,
    height: '100%',
    border: '2px solid',
    borderColor: 'divider',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    p: '1rem !important',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'primary.50',
      transform: 'translateY(-2px)',
      boxShadow: 2,
    },
  },
  cardContent: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContainer: {
    mb: 2,
  },
  icon: {
    fontSize: 48,
    color: 'text.secondary',
  },
  title: {
    mb: 1,
  },
  description: {
    mb: 3,
    maxWidth: 200,
  },
};

export default UploadDropzoneCard;
